<script setup>
import items from "./Help.json";
//import items from "./test.json";
</script>
<template>
	<v-menu
		v-model="open_flg"
		absolute
	>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
			icon
        >
			<v-icon>
				mdi-help-circle-outline
			</v-icon>
        </v-btn>
      </template>
		<v-card
			width="300px"
			max-height="90vh"
		>
			<v-toolbar
				color="#E11D31"
				height="20px"
				flat
			>
			</v-toolbar>
			<v-card-title v-html="items[item_num].title" />
			<v-card-text style="color:black;" v-html="items[item_num].text" />
		</v-card>
	</v-menu>
</template>
<script>
export default {
	props : ["num"],
	computed : {
		item_num : function(){
			let keep_num = -1;
			let i = 0;
			for(i = 0 ; i < this.items.length ; i++)
			{
				if(this.items[i].route == this.$route.path)
				{
					if(this.num != undefined)
					{
						if(this.num == this.items[i].num)
						{
							break;
						}
						else if(keep_num == -1 && this.items[i].num==0)
						{
							keep_num = i;
						}
					}
					else
					{
						break;
					}
				}
			}
			if(i == this.items.length && keep_num == -1)
			{
				i=0;
			}
			else if(keep_num != -1 && i == this.items.length)
			{
				i=keep_num;
			}
			return i;
		},
	},
	data : function(){
		return {
			open_flg : false,
			items    : items,
		};
	},
}
</script>
